document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuButton = document.querySelector('[data-mobile-menu-button]')
  const mobileMenuSection = document.querySelector('[data-mobile-menu]')
  const anchorLink = document.querySelectorAll('[data-anchor-link]')

  if (mobileMenuButton && mobileMenuSection) {
    mobileMenuButton.addEventListener('click', () => {
      if (mobileMenuButton.textContent === 'Menu') {
        mobileMenuButton.textContent = 'Luk'
        mobileMenuSection.setAttribute('data-mobile-menu', 'open')
      } else {
        mobileMenuButton.textContent = 'Menu'
        mobileMenuSection.setAttribute('data-mobile-menu', 'closed')
      }
    })
  }

  const headlines = document.querySelectorAll('[data-headline-mobile]')
  headlines.forEach(headline => {
    headline.addEventListener('click', () => {
      const links = headline.parentElement.querySelector('[data-links]')
      if (links) {
        const isOpen = links.getAttribute('data-link') === 'open'
        links.setAttribute('data-link', isOpen ? 'closed' : 'open')
        headline.setAttribute('data-headline-mobile', isOpen ? 'closed' : 'open')
      }
    })
  })

  anchorLink.forEach(link => {
    link.addEventListener('click', _event => {
      const links = link.closest('[data-links]')
      if (links) {
        links.setAttribute('data-link', 'closed')
        const headline = links.previousElementSibling
        if (headline) {
          headline.setAttribute('data-headline-mobile', 'closed')
        }
      }
      const mobileMenuButton = document.querySelector('[data-mobile-menu-button]')
      const mobileMenuSection = document.querySelector('[data-mobile-menu]')
      if (mobileMenuButton && mobileMenuSection) {
        mobileMenuButton.textContent = 'Menu'
        mobileMenuSection.setAttribute('data-mobile-menu', 'closed')
      }
      console.log('link')
    })
  })
})
